import { RemoveCircle } from '@mui/icons-material';
import { DataGridPremium, GridActionsCellItem } from '@mui/x-data-grid-premium';
import { useState } from 'react';
import { CustomToolbar } from 'shared/components';
import { useColumns } from 'shared/hooks';
import { GridColumns } from 'shared/types';
import { moneyFourDecimalFormatter } from 'shared/utility/dataGrid';
import { AddDeviationsData } from 'types/backend';

type SelectedProductsTableProps = {
    selectedProducts: AddDeviationsData[];
    setSelected: React.Dispatch<React.SetStateAction<AddDeviationsData[]>>;
};

export function SelectedProductsTable({ selectedProducts, setSelected }: SelectedProductsTableProps) {
    const handleClick = (params: AddDeviationsData) => () => {
        setSelected((prevSelected) => prevSelected.filter((selectedItem) => selectedItem.id !== params.id));
    };

    const columnConfig: GridColumns<AddDeviationsData> = [
        {
            headerName: 'Select Products',
            field: 'actions',
            type: 'actions',
            hide: false,
            filterable: false,
            pinnable: false,
            width: 200,
            getActions: (params) => [
                <GridActionsCellItem icon={<RemoveCircle />} label='Select' onClick={handleClick(params.row)} />,
            ],
        },
        {
            headerName: 'Product',
            field: 'productId',
            hideable: false,
            pinnable: false,
            width: 200,
        },
        {
            headerName: 'Group',
            field: 'group',
            hideable: false,
            pinnable: false,
            width: 200,
        },
        {
            headerName: 'Type',
            field: 'type',
            hideable: false,
            pinnable: false,
            width: 100,
        },
        {
            headerName: 'Gauge',
            field: 'gauge',
            hideable: false,
            pinnable: false,
            type: 'number',
            width: 100,
        },
        {
            headerName: 'Length',
            field: 'length',
            hideable: false,
            pinnable: false,
            type: 'number',
            width: 100,
        },
        {
            headerName: 'Width',
            field: 'width',
            hideable: false,
            pinnable: false,
            type: 'number',
            width: 100,
        },
        {
            headerName: 'Tier 1 Target Price',
            field: 'tierOnePrice',
            hideable: false,
            pinnable: false,
            type: 'number',
            valueFormatter: moneyFourDecimalFormatter,
            width: 100,
        },
        {
            headerName: 'Customer Target Price',
            field: 'targetPrice',
            hideable: false,
            pinnable: false,
            valueFormatter: moneyFourDecimalFormatter,
            type: 'number',
            filterable: false,
            width: 200,
        },
        {
            headerName: 'Market Price',
            field: 'price',
            hideable: false,
            pinnable: false,
            valueFormatter: moneyFourDecimalFormatter,
            type: 'number',
            filterable: false,
            width: 200,
        },
    ];

    const columns = useColumns<AddDeviationsData>({ columnConfig });

    const [filterButtonEl, setFilterButtonEl] = useState<HTMLButtonElement | null>(null);

    return (
        <DataGridPremium
            autoHeight
            getRowId={(row) => row.id}
            columns={columns}
            rows={selectedProducts}
            components={{
                Toolbar: CustomToolbar,
            }}
            componentsProps={{
                panel: {
                    anchorEl: filterButtonEl,
                    sx: {
                        '& .MuiDataGrid-filterFormColumnInput': {
                            width: 'auto',
                        },
                    },
                },
                toolbar: {
                    setFilterButtonEl,
                    hideExport: true,
                    title: 'Selected Products',
                },
            }}
        />
    );
}
